import React from 'react'

interface InfoCardProps {
  title: string
  value: string
  className?: string
  nested?: boolean
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  value,
  className = '',
  nested = false
}) => {
  const baseClasses = nested
    ? 'bg-white rounded-xl p-5 shadow-2xs'
    : 'bg-white rounded-3xl p-5 shadow-sm'

  return (
    <div className={`${baseClasses} ${className}`}>
      <div className="text-sm text-gray-500 mb-2 font-medium">{title}</div>
      <div className="text-2xl font-bold text-gray-700">{value}</div>
    </div>
  )
}

export default InfoCard
